import { GlButton, GlDisclosureDropdown, GlDisclosureDropdownItem, GlTooltipDirective } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { MountingPortal } from '../../../../../../../app/assets/javascripts/lib/utils/vue3compat/portal_vue_vue3.js?vue3';
import { s__ } from '~/locale';
import DuoWorkItemToMrAction from '../../../ai/shared/widgets/duo_work_item_to_mr_action.vue?vue3';
import DynamicPanel from '../../../../../../../app/assets/javascripts/vue_shared/components/dynamic_panel.vue?vue3';
import WorkplanView from './workplan_view.vue?vue3';
import WorkplanEditor from './workplan_editor.vue?vue3';
import WorkplanAvailabilityPopover from './workplan_availability_popover.vue?vue3';
import { WORKPLAN_GOAL_PREFIX, WORKPLAN_SOURCE, GENERATE_MR_BUTTON_OPTIONS, IMPLEMENTATION_UNAVAILABLE_MESSAGE, IMPLEMENTATION_HELP_PATH } from './constants';
import { isValidReadinessScore, trackWorkplanImplement } from './utils.js?vue3';
export default {
    name: 'WorkplanPanel',
    directives: {
        GlTooltip: GlTooltipDirective
    },
    components: {
        DynamicPanel,
        GlButton,
        GlDisclosureDropdown,
        GlDisclosureDropdownItem,
        MountingPortal,
        DuoWorkItemToMrAction,
        WorkplanView,
        WorkplanEditor,
        WorkplanAvailabilityPopover
    },
    inject: [
        'fullPath'
    ],
    inheritAttrs: false,
    props: {
        generationDisabledReason: {
            type: String,
            required: true
        },
        open: {
            type: Boolean,
            required: true
        },
        canUpdate: {
            type: Boolean,
            required: true
        },
        savedContent: {
            type: String,
            required: true
        },
        savedContentHtml: {
            type: String,
            required: true
        },
        draftContent: {
            type: String,
            required: true
        },
        isEditing: {
            type: Boolean,
            required: true
        },
        isSaving: {
            type: Boolean,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        },
        isFlowActive: {
            type: Boolean,
            required: false,
            default: false
        },
        isActionInFlight: {
            type: Boolean,
            required: false,
            default: false
        },
        isWorkItemClosed: {
            type: Boolean,
            required: false,
            default: false
        },
        workItemIid: {
            type: [
                String,
                Number
            ],
            required: true
        },
        workItemType: {
            type: String,
            required: true
        },
        workItemWebUrl: {
            type: String,
            required: true
        },
        readinessScore: {
            type: Number,
            required: false,
            default: null,
            validator: isValidReadinessScore
        }
    },
    emits: [
        'close',
        'save',
        'delete',
        'draft-change',
        'start-edit',
        'cancel-edit',
        'regenerate',
        'generate'
    ],
    computed: {
        isEditingAllowed () {
            return this.canUpdate && !this.isEditing;
        },
        hasSavedContent () {
            return Boolean(this.savedContent);
        },
        showGenerateMrAction () {
            return !this.isEditing && this.hasSavedContent && !this.isFlowActive && !this.isWorkItemClosed;
        },
        panelHeading () {
            return s__('AgentPlan|Workplan');
        },
        // Both plan actions stay disabled for the whole run, not just the mutation: the menu
        // stays on screen throughout a regenerate because the previous plan keeps
        // `hasSavedContent` true. Regenerate would otherwise be re-offered mid-run, and a
        // delete would be silently undone when the run writes its plan back.
        areRunActionsDisabled () {
            return this.isFlowActive || this.isActionInFlight;
        },
        regenerateItem () {
            return {
                text: s__('AgentPlan|Regenerate workplan'),
                icon: 'tanuki-ai',
                extraAttrs: {
                    disabled: this.areRunActionsDisabled,
                    'aria-disabled': this.areRunActionsDisabled || Boolean(this.generationDisabledReason),
                    class: this.generationDisabledReason ? '!gl-text-disabled' : ''
                },
                action: ()=>{
                    if (!this.generationDisabledReason) {
                        this.$emit('regenerate');
                    }
                }
            };
        },
        deleteItem () {
            return {
                text: s__('AgentPlan|Delete workplan'),
                icon: 'remove',
                variant: 'danger',
                extraAttrs: {
                    disabled: this.areRunActionsDisabled
                },
                action: ()=>{
                    this.$refs.moreActions.close();
                    this.$emit('delete');
                }
            };
        }
    },
    mounted () {
        document.addEventListener('keydown', this.handleKeydown);
    },
    beforeDestroy () {
        document.removeEventListener('keydown', this.handleKeydown);
    },
    methods: {
        trackImplement () {
            trackWorkplanImplement('panel', this.readinessScore);
        },
        handleClose () {
            const active = document.activeElement;
            const activeTag = active?.tagName;
            if (document.body.classList.contains('modal-open') || active?.closest('.js-editor') != null || activeTag === 'INPUT' || activeTag === 'TEXTAREA') {
                return;
            }
            this.$emit('close');
        },
        handleKeydown ({ key }) {
            if (key === 'Escape' && this.open) {
                this.handleClose();
            }
        }
    },
    WORKPLAN_GOAL_PREFIX,
    WORKPLAN_SOURCE,
    generateMrButtonOptions: {
        ...GENERATE_MR_BUTTON_OPTIONS,
        size: 'small'
    },
    IMPLEMENTATION_UNAVAILABLE_MESSAGE,
    IMPLEMENTATION_HELP_PATH
};
